<template>
	<div class="layout-container">
		<!-- 侧边栏 -->
		<div class="layout-sidebar">
			<index-aside></index-aside>
		</div>
		
		<!-- 主内容区域 -->
		<div class="layout-main">
			<!-- 顶部头部 -->
			<div class="layout-header">
			<index-header></index-header>
			</div>
			
			<!-- 面包屑导航 -->
			<div class="layout-breadcrumb" v-if="title">
				<bread-crumbs :title="title"></bread-crumbs>
			</div>
			
			<!-- 页面内容 -->
			<div class="layout-content">
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	import IndexAside from '@/components/index/IndexAsideStatic'
	import IndexHeader from '@/components/index/IndexHeader'
	import menu from "@/utils/menu";
	export default {
		components: {
			IndexAside,
			IndexHeader
		},
		data() {
			return {
				menuList: [],
				role: "",
				currentIndex: -2,
				itemMenu: [],
				title: ''
			};
		},
		mounted() {
			let menus = menu.list();
			this.menuList = menus;
			this.role = this.$storage.get("role");
		},
		created() {
			this.init();
			console.log(console.log(this.$route.path))
		},
		methods: {
			init(){
				this.$nextTick(()=>{
					
				})
			},
			menuHandler(menu) {
				this.$router.push({
					name: menu.tableName
				});
				this.title = menu.menu;
			},
			titleChange(index, menus) {
				this.currentIndex = index
				this.itemMenu = menus;
				console.log(menus);
			},
			homeChange(index) {
				this.itemMenu = [];
				this.title = ""
				this.currentIndex = index
				this.$router.push({
					name: 'home'
				});
			},
			centerChange(index) {
				this.itemMenu = [{
					"buttons": ["新增", "查看", "修改", "删除"],
					"menu": "修改密码",
					"tableName": "updatePassword"
				}, {
					"buttons": ["新增", "查看", "修改", "删除"],
					"menu": "个人信息",
					"tableName": "center"
				}];
				this.title = ""
				this.currentIndex = index
				this.$router.push({
					name: 'home'
				});
				
			}
		}
	};
</script>
<style lang="scss" scoped>
.layout-container {
	display: flex;
	height: 100vh;
	background: #f8fafc;
	overflow: hidden;
	}

.layout-sidebar {
	width: 240px;
	background: #ffffff;
	border-right: 1px solid #e2e8f0;
	flex-shrink: 0;
	overflow: hidden;
	z-index: 1000;
	}
	
.layout-main {
	flex: 1;
	display: flex;
	flex-direction: column;
	min-width: 0;
	overflow: hidden;
}

.layout-header {
	background: #ffffff;
	border-bottom: 1px solid #e2e8f0;
	flex-shrink: 0;
	z-index: 999;
}

.layout-breadcrumb {
	padding: 16px 24px;
	background: #ffffff;
	border-bottom: 1px solid #f1f5f9;
	flex-shrink: 0;
}

.layout-content {
	flex: 1;
	padding: 24px;
	overflow-y: auto;
	background: #f8fafc;
	
	// 内容区域的卡片样式
	:deep(.el-card) {
		border: none;
		box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
		border-radius: 8px;
	}
	
	// 表格样式优化
	:deep(.el-table) {
		border: none;
		
		.el-table__header {
			background: #f8fafc;
			
			th {
				background: #f8fafc;
				border-bottom: 1px solid #e2e8f0;
				color: #374151;
				font-weight: 600;
			}
		}
		
		.el-table__body {
			tr {
				&:hover {
					background: #f8fafc;
				}
			}
			
			td {
				border-bottom: 1px solid #f1f5f9;
			}
		}
	}
	
	// 表单样式优化
	:deep(.el-form) {
		.el-form-item__label {
			color: #374151;
			font-weight: 500;
		}

		.el-input__inner,
		.el-textarea__inner {
			border-color: #e2e8f0;
			
			&:focus {
				border-color: #3b82f6;
				box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
			}
		}
	}
	
	// 按钮样式优化
	:deep(.el-button) {
		border-radius: 6px;
		font-weight: 500;
		
		&.el-button--primary {
			background: #3b82f6;
			border-color: #3b82f6;
			
			&:hover {
				background: #2563eb;
				border-color: #2563eb;
		}
	}
	}
}

// 响应式设计
@media (max-width: 1024px) {
	.layout-sidebar {
		width: 200px;
	}
	
	.layout-content {
		padding: 20px;
	}
}

@media (max-width: 768px) {
	.layout-container {
		flex-direction: column;
	}
	
	.layout-sidebar {
		width: 100%;
		height: auto;
		border-right: none;
		border-bottom: 1px solid #e2e8f0;
	}
	
	.layout-content {
		padding: 16px;
	}
}

// 通用样式
a {
	text-decoration: none;
	color: #374151;
	transition: color 0.2s ease;
	
	&:hover {
		color: #3b82f6;
		}
	}
	
	.detail-form-content {
	    background: transparent;
	}
</style>
